import styled, { keyframes, css } from "styled-components";

const shakeAnimation = keyframes`
0% { transform: translateX(0); }
25% { transform: translateX(-3px); }
75% { transform: translateX(3px); }
100% { transform: translateX(0); }
`;

export const ModuleContainer = styled.div`
  display: flex;
  flex-direction: column;

 /* animation: ${({ isEditing }) =>
    isEditing
      ? css`
          ${shakeAnimation} 0.4s ease-in-out infinite
        `
      : "none"};
      */
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  border: 2px solid #eb5757;
  box-sizing: border-box;
  border-radius: 5px;
  background-color: #ccc;
  position: relative;
`;

export const IconContainer = styled.div`
  background-color: #eb5757;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  margin-right: 1rem;
`;

export const IconStyle = {
  color: "inherit",
  fontSize: "24px",
};

export const ExtentionContainer = styled.div`
  height: 20rem;
  overflow-y: auto;
  margin-top: 0.5rem;

  ::-webkit-scrollbar {
    width: 4px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: gainsboro;
    border-radius: 6px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background-color: #212326;
    border-radius: 6px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #000;
  }
`;

export const RefreshDeleteContainer = styled.div`
  position: absolute;
  right: 5px;
  top: 0px;
`;
